import { Card, CardContent } from '@/components/ui/card';
import { CardHeader } from '../CardHeader';
import { PrizeItem } from './PrizeItem';
import bolt from "@/assets/funnel-bolt.svg";
import moneymint from "@/assets/moneymint.png";
import millionairemaker from "@/assets/MillionaireMaker.png";
import crazy99s from "@/assets/Crazy99s.png";
import triplecashblast from "@/assets/TripleCashBlast.png"
import { ShineEffect } from '../ShineEffect';



export type Prize = {
    name: string;
    amount: string;
    cost: string;
    textColor: string;
    bgColor: string;
    borderColor: string;
    src: string;
  };

const prizesConst: Prize[] = [
    {
        name: "The Money Mint",
        amount: "$550,000",
        cost: "$25",
        textColor: "text-green-500",
        bgColor: "bg-green-500",
        borderColor: "border-green-500",
        src: moneymint
    },
    {
        name: "Millionaire Maker",
        amount: "$1,265,000",
        cost: "$50",
        textColor: "text-blue-400",
        bgColor: "bg-blue-400",
        borderColor: "border-blue-400",
        src: millionairemaker
    },
    {
        name: "Crazy 99s",
        amount: "$99,000",
        cost: "$10",
        textColor: "text-purple-500",
        bgColor: "bg-purple-500",
        borderColor: "border-purple-500",
        src: crazy99s
    },
    {
        name: "Triple Cash Blast",
        amount: "$850,000",
        cost: "$40",
        textColor: "text-yellow-400",
        bgColor: "bg-yellow-400",
        borderColor: "border-yellow-400",
        src: triplecashblast
    }
];

export function OtherAvailableCards({ prizes = prizesConst }: { prizes?: Prize[] }) {

    return (
        <Card className="max-w-md rounded-lg overflow-hidden shadow-md bg-white border-0" id='otheravailablecard-card'>
            <CardHeader title="Other Available Cards" />
            <CardContent className="p-0">
                {/* Header */}
                <ShineEffect>
                    <div className="bg-green text-white p-3 flex justify-center items-center space-x-3">
                        <h1 className="text-xl font-bold">Huge prizes 24/7</h1>
                        <div className="bg-white px-2 py-0.5 rounded-sm flex items-center space-x-1">
                            <img src={bolt} className='h-4' alt='instant'/>
                            <span className="text-md text-gold font-semibold">Instant</span>
                        </div>
                    </div>
                </ShineEffect>


                {/* Prize Cards */}
                <div className="divide-y divide-gray-200">
                    {prizes.map((prize) => (
                        <PrizeItem key={`${prize.name}-available`} prize={prize} />
                    ))}
                </div>
            </CardContent>
        </Card>
    );
}